import { render, staticRenderFns } from "./TagAgents.vue?vue&type=template&id=b0606280&scoped=true&"
import script from "./TagAgents.vue?vue&type=script&lang=js&"
export * from "./TagAgents.vue?vue&type=script&lang=js&"
import style0 from "./TagAgents.vue?vue&type=style&index=0&id=b0606280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0606280",
  null
  
)

export default component.exports